import requestWrapper from './requestWrapper';
import endpoints from './endpoints';
import requests from './requests';

export default {
	endpoints,
	...requests,
	...requestWrapper,
};
